import React from 'react';
import Platforms from './Platforms';

export function TopNavPlatforms() {
  return <Platforms />;
}

export default TopNavPlatforms;